import React from 'react';

import styled from 'styled-components';

import theme from '../theme';

import Icon from '../Icon';
import { Paragraph } from '../Typography';

interface PlacesFooter {
  enableManualInput: () => void;
}

const PlacesFooter: React.FC<PlacesFooter> = ({ enableManualInput }) => (
    <Container>
      <Divider />
      <TouchableContainer
        onMouseDown={ev => ev.preventDefault()}
        onClick={enableManualInput}
      >
        <PlusIcon />
        <StyledParagraph>Manually Enter Address</StyledParagraph>
      </TouchableContainer>
    </Container>
  );

export default PlacesFooter;

const Container = styled.div`
  padding-bottom: 7px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

const PlusIcon = styled(Icon).attrs({
  color: 'gray7',
  height: 18,
  width: 18,
  type: 'plus',
})``;

const TouchableContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 9.5px;
  &:hover {
    background-color: ${theme.gray5};
    cursor: pointer;
  }
`;

const StyledParagraph = styled(Paragraph)`
  && {
    text-indent: 6px;
    font-size: 14px;
    line-height: 22px;
    color: ${theme.gray8};
    margin-bottom: 0px;
  }
`;

const Divider = styled.div`
  border: 1px solid ${theme.gray4};
  width: 90%;
  margin: 0px auto 7px auto;
`;
